import Enumerator from '../global/Enumerator';

export const workflowTypes = [
  'none',
  'asset_finance',
  'commercial_loan',
  'conveyancing',
  'home_loan',
  'insurance',
  'personal_loan',
  'real_estate',
  'risk_insurance'
];

export class WorkflowType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(type?: string) {
    let realType = type;
    switch (type) {
      case 'assetfinance':
        realType = 'asset_finance';
        break;
      case 'commercialloan':
        realType = 'commercial_loan';
        break;
      case 'conveyancing':
        realType = 'conveyancing';
        break;
      case 'homeloan':
        realType = 'home_loan';
        break;
      case 'insurance':
        realType = 'insurance';
        break;
      case 'personalloan':
        realType = 'personal_loan';
        break;
      case 'realestate':
        realType = 'real_estate';
        break;
      default:
        break;
    }
    return this.enumValueOf(realType) || this.default();
  }
}
WorkflowType.initEnum(workflowTypes);

export default {
  workflowTypes,
  WorkflowType
};
